import { pdfStore } from "@/slices/pdfViewer";
import { Attachment } from "@mui/icons-material";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { useEffect, useState } from "react";

export default function AttachmentViewer() {
	const [anchorEl, setAnchorEl] = useState(null);
	const [attachments, setAttachments] = useState([]);
	const open = Boolean(anchorEl);
	const currentDocument = pdfStore.getState().document;

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleAttachmentOnClick = (attachment) => () => {
		setAnchorEl(null);
		const fileBlob = new Blob([attachment.content]);
		const objectUrl = URL.createObjectURL(fileBlob);
		window.open(objectUrl, "attachmentWindow");
		URL.revokeObjectURL(objectUrl);
	};

	useEffect(() => {
		async function getCurrentDocumentsAttachments() {
			try {
				const attachmentEntries = await currentDocument.getAttachments();
				if (attachmentEntries != null) {
					const files = Object.values(attachmentEntries);
					setAttachments(files);
				}
			} catch (error) {
				console.error("Error fetching attachments:", error);
			}
		}
		if (currentDocument != null) {
			getCurrentDocumentsAttachments();
		}
	}, [currentDocument]);

	return (
		<>
			<IconButton
				disabled={attachments.length === 0}
				onClick={handleClick}
				size="small">
				<Attachment className="text-[length:inherit]" />
			</IconButton>
			<Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
				{attachments.map((attachment, index) => (
					<MenuItem key={index} onClick={handleAttachmentOnClick(attachment)}>
						{attachment.filename}
					</MenuItem>
				))}
			</Menu>
		</>
	);
}
